import {
  SMVM_RECORDING_FAIL,
  SMVM_RECORDING_REQUEST,
  SMVM_RECORDING_RESET,
  SMVM_RECORDING_SUCCESS,
} from "../constants/recordingConstants";

export const smvm_recording_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case SMVM_RECORDING_REQUEST:
      return { loading: true };
    case SMVM_RECORDING_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_RECORDING_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_RECORDING_RESET:
      return {};
    default:
      return state;
  }
};
